// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__deV4O","label":"Completed_label__35qCf"};